type FormatListParams = {
	values: Iterable<string>;
	locale?: string;
	style?: Intl.ListFormatStyle;
	type?: Intl.ListFormatType;
};

export const formatList = ({ values, locale, style = "long", type = "conjunction" }: FormatListParams) => {
	const listValues = [...values];
	if (typeof Intl?.ListFormat !== "function") {
		return listValues.join(", ");
	}
	return new Intl.ListFormat(locale || "en", { style, type }).format(listValues);
};
